import { isGoBack } from 'lib/react-router-dom'
import { initialState } from 'store/grid/grid.slice'
import { GridFilterActionState } from 'store/grid/types'

import { useGridState } from './useGridState'
import { GridStateStatusActions } from './useGridStatusState'

interface GridFilterHelperProps {
  selectFilterForGoBackHistory(gridFilterState: GridFilterActionState): GridFilterActionState
}

export const useGridFilter = (gridStatusActions: GridStateStatusActions): GridFilterHelperProps => {
  const { gridState } = useGridState()

  const selectFilterForGoBackHistory = (gridFilterState: GridFilterActionState) => {
    const filterId = gridFilterState.filterName
    const filtersSize = gridState?.filter?.filters?.length ?? 0

    if (isGoBack && filterId && filtersSize > 0) {
      gridStatusActions.setGridFilterName(filterId)
      gridStatusActions.setFilterMode(true)
      gridStatusActions.setFilterSelected(true)
      return gridFilterState
    }

    if (isGoBack && filtersSize > 0) {
      gridStatusActions.setGridFilterName('')
      gridStatusActions.setCreateMode(true)
      gridStatusActions.setFilterMode(true)
      gridStatusActions.setFilterSelected(false)
      return gridFilterState
    }

    if (isGoBack && gridState?.pageIndex > 1) {
      return gridFilterState
    }

    gridStatusActions.resetAll()
    return initialState()
  }

  return {
    selectFilterForGoBackHistory,
  }
}
